<template>
  <form @submit.prevent="uploadDocument()" enctype="multipart/form-data">
    <div class="input-group">
      <input
        type="file"
        class="form-control form-control-sm"
        multiple
        required
        @change="filesChange($event.target.files)"
      />
      <button class="btn btn-xs btn-primary" title="jegyzőkönyv feltöltése">
        <i class="fa fa-upload"></i>
      </button>
    </div>
  </form>
</template>

<script>
import File from "../apis/File.js";
export default {
  props: { model_name: String, model_id: Number, secondary_id: Number },
  data() {
    return {
      formDataToSend: null,
    };
  },
  methods: {
    uploadDocument() {
      File.upload(this.formDataToSend);
      this.$emit("upload");
    },
    filesChange(fileList) {
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append("log_files[]", fileList[x], fileList[x].name);
      });

      formData.append("model_name", this.model_name);
      formData.append("model_id", this.model_id);
      formData.append("secondary_id", this.secondary_id);
      this.formDataToSend = formData;
    },
  },
};
</script>
